import { Injectable } from "@angular/core";
import CryptoJS from "crypto-js";
import { environment } from "environments/environment";

@Injectable({
  providedIn: "root",
})
export class EncripterService {
  constructor() {}

  set(keys: string | null, value: string) {
    if (keys === null) {
      keys = environment.appKey;
    }

    const key = CryptoJS.enc.Utf8.parse(keys);
    const iv = CryptoJS.enc.Base64.parse(environment.iv);
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key, {
      keySize: 128 / 8,
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  }

  get(keys: string | null, value: string) {
    if (keys === null) {
      keys = environment.appKey;
    }

    const key = CryptoJS.enc.Utf8.parse(keys);
    const iv = CryptoJS.enc.Base64.parse(environment.iv);
    try {
      const decrypted = CryptoJS.AES.decrypt(value.toString(), key, {
        keySize: 128 / 8,
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch {
      return null;
    }
  }
}
